import { useTranslation } from "next-i18next"

const useProductListi18n = () => {
  const { t } = useTranslation()
  const i18n = {
    noResultsMssg: t("kf.plp.label.noResultsMssg"),
  }

  return i18n
}

export default useProductListi18n
